import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";

import { useOrganizationContextLoader } from "./organization-context-loader.hook";

export const OrganizationContextLoader = () => {
  const showLoader = useOrganizationContextLoader();

  if (!showLoader) return null;

  return <Spin indicator={<LoadingOutlined spin />} size="small" />;
};
